import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { OperationModificative } from '../texte.model';

@Injectable({providedIn: 'root'})
@Pipe({
	name: 'articleCible', 
	pure: false // La classe ne modifie pas son argument mais c'est nécessaire
})
export class ArticleCiblePipe implements PipeTransform {

	transform(operation: OperationModificative): string {
		if (operation.txt_cible == undefined || operation.art_id_cible == undefined) {
			return '';
		}

		for (let article of operation.txt_cible.articles) {
			if (operation.art_id_cible === article.art_id) {
				return article.art_titre ?? '';
			}
		}
		return ''
	}
}
